require('./bootstrap')

// require('alpinejs')

import router from './router'

window.onload = function () {
    if (document.getElementById('app')) {
        alert(document.getElementById('app'))
        const app = new Vue({
            el: '#app',
            router
        });
    }

}



